export type SmartTableCellReconciliationReason =
  | "cancellation"
  | "execution_terminal"
  | "malformed_event"
  | "poll"
  | "reconnect"
  | "recovery_failed"
  | "visibility_restored";

export interface SmartTableCellReconciliationRequest {
  tableId: string;
  sheetId: string;
  reason: SmartTableCellReconciliationReason;
}

const SMART_TABLE_CELL_RECONCILIATION_EVENT = "promptlayer:smart-table-cell-reconciliation";

export const requestSmartTableCellReconciliation = (
  request: SmartTableCellReconciliationRequest,
): void => {
  window.dispatchEvent(
    new CustomEvent<SmartTableCellReconciliationRequest>(SMART_TABLE_CELL_RECONCILIATION_EVENT, {
      detail: request,
    }),
  );
};

export const subscribeToSmartTableCellReconciliation = (
  listener: (request: SmartTableCellReconciliationRequest) => void,
): (() => void) => {
  const handleRequest = (event: Event) => {
    const request = (event as CustomEvent<SmartTableCellReconciliationRequest>).detail;
    if (!request) {
      return;
    }

    listener(request);
  };

  window.addEventListener(SMART_TABLE_CELL_RECONCILIATION_EVENT, handleRequest);
  return () => window.removeEventListener(SMART_TABLE_CELL_RECONCILIATION_EVENT, handleRequest);
};
